class FeaturedProductSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.section-featured-product-slider-swiper');
    if (!swiperEl) return;

    // Initialize Swiper
    this.swiper = new Swiper(swiperEl, {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: false,
        navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          0: { 
            slidesPerView: 1.1, 
            spaceBetween: 12 
          },
          480: { 
            slidesPerView: 2, 
            spaceBetween: 12 
          },
          768: { 
            slidesPerView: 2.5, 
            spaceBetween: 18 
          },
          1024: { 
            slidesPerView: 3, 
            spaceBetween: 32 
          }
        }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define('featured-product-slider', FeaturedProductSlider);